<!-- Modal -->
<div class="modal fade" id="staticBackdrop" id="modal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Términos y condiciones</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="margin-left: 20pt; margin-right: 50pt;">
        <h2
          style='margin-top:2.0pt;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;line-height:107%;font-size:17px;font-family:"Calibri Light",sans-serif;color:#2F5496;font-weight:normal;'>
          <span style="font-size:19px;line-height:107%;">T&eacute;rminos y condiciones:</span>
        </h2>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;'>
          &nbsp;</p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>T&Eacute;RMINOS Y CONDICIONES
            DEL PROCESO DE MATR&Iacute;CULA ONLINE</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>UNIVERSIDAD SANTO
            TOM&Aacute;S</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>I. &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp;BIENVENIDA.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>La presente p&aacute;gina
            contiene informaci&oacute;n acerca de la forma en que se desarrolla este proceso y describe los
            t&eacute;rminos y condiciones bajo los que se rige.&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Le invitamos a que,
            antes de proceder a matricularse, se informe acerca de nuestra instituci&oacute;n y de las
            caracter&iacute;sticas de la carrera que pretende tomar, tales como: el perfil de egreso, campo ocupacional,
            aranceles, horario, etc. Toda esa informaci&oacute;n se encuentra disponible en el sitio web de Santo
            Tom&aacute;s que puede ser consultado en https://www.santotomas.cl/</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>II. &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; ACEPTACI&Oacute;N DE LOS T&Eacute;RMINOS Y CONDICIONES DEL PROCESO MATR&Iacute;CULA
            ONLINE.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Una vez que haya le&iacute;do
            los presentes t&eacute;rminos y condiciones, se solicita aceptar expresamente estos t&eacute;rminos haciendo
            clic en el bot&oacute;n que se encuentra al final de esta p&aacute;gina. Usted podr&aacute; proseguir el
            proceso en l&iacute;nea &uacute;nicamente si acepta los t&eacute;rminos y condiciones.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>III. &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp;SOBRE EL PROCESO DE MATR&Iacute;CULA ONLINE.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>1. &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; Requisitos para postular dentro del proceso de Matr&iacute;cula Online:</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Para que usted pueda
            matricularse en l&iacute;nea, es necesario que usted cumpla con los siguientes requisitos:</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>a.&nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;Ser mayor de 18 a&ntilde;os. Si es menor de edad, deber&aacute; realizar su matr&iacute;cula en cualquier sede Santo Tom&aacute;s a lo largo del pa&iacute;s.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>b.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;Tener c&eacute;dula nacional de identidad emitida por el Registro Civil e Identificaci&oacute;n
            de la Rep&uacute;blica de Chile, vigente a la fecha de la matr&iacute;cula.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>c.&nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;Tener clave &uacute;nica del registro civil. https://codigo.registrocivil.cl/</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>d.&nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;Cumplir con los requisitos espec&iacute;ficos de las carreras se&ntilde;aladas a trav&eacute;s de la
            p&aacute;gina web de admisi&oacute;n https://www.tupuedes.cl/</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>e.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;Postular dentro del periodo en que la interfaz de Matr&iacute;cula Online se encuentre abierta.
            La fecha de inicio de los procesos ser&aacute; informada en https://www.tupuedes.cl/.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>f.&nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;No poseer alguna situaci&oacute;n financiera o acad&eacute;mica pendiente con la
            Instituci&oacute;n.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>2. &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; Sobre los pasos del proceso de matr&iacute;cula online:</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>El proceso MATR&Iacute;CULA
            ONLINE consta de los siguientes pasos:</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>a.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;CREACI&Oacute;N DE CUENTA.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>b.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;DATOS PERSONALES Y DATOS DE POSTULACI&Oacute;N.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>c.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;&nbsp;ARANCELES DE LA CARRERA.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>d.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;DOCUMENTOS REQUERIDOS Y CARGA DE DOCUMENTOS.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>e.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;GENERACI&Oacute;N Y FIRMA ELECTR&Oacute;NICA DE CONTRATO DE PRESTACI&Oacute;N DE SERVICIOS
            EDUCACIONALES.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>f.&nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;&nbsp;MATR&Iacute;CULA.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>A continuaci&oacute;n, se
            detalla cada uno de estos pasos:</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>a) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; CREACI&Oacute;N DE CUENTA.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>El uso del sistema requiere
            de un registro y clave de acceso, que se genera desde el portal de matr&iacute;cula online. El resguardo de
            la clave y acceso es de responsabilidad del usuario.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>b) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; DATOS PERSONALES Y DATOS DE POSTULACI&Oacute;N</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Se solicita confirmar datos
            personales b&aacute;sicos y confirmar la Carrera/Sede en la que fue seleccionado.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>c) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; ARANCELES DE LA CARRERA</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>El sistema le mostrar&aacute; los aranceles de matr&iacute;cula, colegiatura, descuento y 
            becas que est&eacute;n vigentes y asignadas al momento de ejecutar el proceso de matr&iacute;cula.&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>d) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; DOCUMENTOS REQUERIDOS Y CARGA DE DOCUMENTOS</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Dependiendo de la
            carrera, el sistema Matr&iacute;cula Online le solicitar&aacute; adjuntar los documentos.&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>IMPORTANTE: Los documentos y
            antecedentes adjuntados en &ldquo;Matr&iacute;cula Online&rdquo; deben ser oficiales y v&aacute;lidamente
            emitidos por la entidad correspondiente. En consecuencia, el alumno asume toda responsabilidad derivada de
            la no existencia, falsedad o adulteraci&oacute;n de cualesquiera de los antecedentes exigidos por la
            Instituci&oacute;n y/o la normativa vigente para estudiar la carrera a la cual se matricula.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>e) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp;GENERACI&Oacute;N Y FIRMA ELECTR&Oacute;NICA DE CONTRATO DE PRESTACI&Oacute;N DE
            SERVICIOS EDUCACIONALES</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Se desplegar&aacute; la 
            opci&oacute;n de solicitar el Contrato de Servicios Educacionales para su revisi&oacute;n
            y posterior firma electr&oacute;nica.&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Usted deber&aacute; leer con
            atenci&oacute;n los derechos y obligaciones que se obligan en virtud de dicho
            Contrato. Una vez hecho lo anterior, deber&aacute;n aceptar los t&eacute;rminos y
            condiciones del Contrato de Prestaci&oacute;n de Servicios Educacionales.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>La firma electr&oacute;nica
            de los contratos se realiza con el servicio de ECERT https://www.e-certchile.cl/, con el sistema de Clave &Uacute;nica.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>IMPORTANTE: En caso
            de no tener Clave &Uacute;nica puede gestionarla en https://claveunica.gob.cl/
            &nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>
            Si es menor de edad, no podr&aacute; realizar la matr&iacute;cula por este servicio y 
            debe contactar directamente a la sede de su inter&eacute;s.&nbsp;</span>
        </p>
        
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>f) &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; MATR&Iacute;CULA&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>Una vez completado el proceso
            de matr&iacute;cula, usted recibir&aacute; un correo electr&oacute;nico con copia de su Contrato de
            Servicios Educacionales suscrito electr&oacute;nicamente con la instituci&oacute;n.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>3.- Uso de datos
            personales&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>El postulante acepta que
            todos los datos personales proporcionados por &eacute;l y su Apoderado Sostenedor, podr&aacute;n ser
            utilizados por la instituci&oacute;n para sus fines propios, esto es: docencia, investigaci&oacute;n,
            extensi&oacute;n y gesti&oacute;n institucional, en general.</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>4.- Consulta a entidades
            externas</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>El postulante acepta y
            autoriza a la instituci&oacute;n a consultar en l&iacute;nea al: registro civil y ministerio de
            educaci&oacute;n, informaci&oacute;n requerida para el proceso,</span>
        </p>
        <p
          style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'>
          <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>&nbsp;</span>
        </p>
        <div
          style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:36.0pt;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;border:none;border-bottom:solid windowtext 1.0pt;padding:0cm 0cm 1.0pt 0cm;'>
          <p
            style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;border:none;padding:0cm;'>
            <span style='font-size:16px;line-height:107%;font-family:"Segoe UI",sans-serif;'>DECLARO HABER LE&Iacute;DO
              Y ACEPTAR LOS T&Eacute;RMINOS Y CONDICIONES, LAS POL&Iacute;TICAS DE PRIVACIDAD DEL PROCESO DE
              MATR&Iacute;CULA ONLINE DEL Y LAS POL&Iacute;TICAS Y REGLAMENTOS ACAD&Eacute;MICOS DE LA
              INSTITUCI&Oacute;N</span>
          </p>
        </div>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal"
          (click)='SendFormContact(true)'>Aceptar</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          (click)='SendFormContact(false)'>Cerrar</button>
      </div>

    </div>
  </div>
</div>